import Resource from '@/plugins/sdk/Resource'
import { UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import { GET } from '@/plugins/sdk/Request'
import Profile from '@/plugins/sdk/resources/Profile'
import Account from '@/plugins/sdk/resources/Account'
import Level from '@/plugins/sdk/resources/Level'
import Role from '@/plugins/sdk/resources/Role'
import Tenancy from '@/plugins/sdk/resources/Tenancy'
import Team from '@/plugins/sdk/resources/Team'

export default class extends Resource {
  static name = 'session'

  static get fields () {
    return {
      id: new UUID(),
      profile: new ITEM(Profile),
      account: new ITEM(Account),
      level: new ITEM(Level),
      role: new ITEM(Role),
      tenancy: new ITEM(Tenancy),
      teams: new COLLECTION(Team),
      team: new ITEM(Team)
    }
  }

  /** @inheritdoc */
  static async _request (resource, method, callback) {
    return super._request(resource, method, builder => {
      if (typeof callback === 'function') {
        callback(builder)
      }

      if (method === GET && typeof resource.id === 'undefined') {
        builder._pathname = 'session'
      }
    })
  }
}
